import React, { useContext } from 'react'
import { Modal } from 'oio-react'
import PropTypes from 'prop-types'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import EventCheckInDesk from 'src/sites/kits/Events/apps/CheckInDesk'
import EventSchedule from 'src/sites/kits/Events/apps/Schedule'
import ObjectJoin from 'src/sites/kits/Object/apps/Join'
import PageCreate from 'src/sites/kits/Object/apps/PageCreate'
import ModalRoute from 'src/sites/kits/Utils/ModalRoute'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import GroupEvents from './Events'
import Files from './Files'
import ObjectHome from './Home'
import NestedCustomPage from './NestedCustomPage'
import People from './People'
import TempObjectSettings from './Settings'

const ObjectViewRoutes = ({ contentPaddingLeft, contentPaddingRight }) => {
   const history = useHistory()
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)

   return (
      <Switch>
         <Route
            exact
            path={`${match.path}`}
            render={() => (
               <ObjectHome
                  paddingLeft={contentPaddingLeft}
                  paddingRight={contentPaddingRight}
               />
            )}
         />
         <Route
            path={`${match.path}/-/events`}
            render={() => (
               <GroupEvents
                  paddingLeft={contentPaddingLeft}
                  paddingRight={contentPaddingRight}
               />
            )}
         />
         {/* TODO: Deprecate - see #866 */}
         <Route
            path={`${match.path}/-/files`}
            render={() => (
               <Files />
            )}
         />
         <Route
            path={`${match.path}/-/join`}
            render={() => (
               <>
                  <ObjectJoin onClose={() => history.push(match.url)} />
                  <ObjectHome />
               </>
            )}
         />
         <Route
            path={`${match.path}/-/people`}
            render={() => (
               <People
                  paddingLeft={contentPaddingLeft}
                  paddingRight={contentPaddingRight}
               />
            )}
         />
         <Route
            path={`${match.path}/-/pages/create`}
            render={() => (
               <PageCreate
                  onCancelButtonClick={() => history.push(match.url)}
                  onCreate={page => history.push(`${match.url}/${page.slug}`)}
                  paddingLeft={contentPaddingLeft}
                  paddingRight={contentPaddingRight}
               />
            )}
         />
         <Route
            path={`${match.path}/:pageSlug([a-zA-Z0-9][^/]+)`}
            render={() => (
               <NestedCustomPage
                  paddingLeft={contentPaddingLeft}
                  paddingRight={contentPaddingRight}
               />
            )}
         />
         {initiative.class === 'event' && (
            <Route
               path={`${match.path}/-/schedule/:selectedDateKey?`}
               render={() => (
                  <EventSchedule
                     paddingLeft={contentPaddingLeft}
                     paddingRight={contentPaddingRight}
                  />
               )}
            />
         )}
         {initiative.class === 'event' && initiative.currentUserCanEdit && (
            <ModalRoute path={`${match.path}/-/checkin`}>
               {({ open, onCloseComplete, onCloseTrigger }) => (
                  <Modal
                     borderRadius="6px"
                     overlayBackgroundColor="rgba(0,0,0,0.85)"
                     width="100%"
                     height="100%"
                     onCloseComplete={onCloseComplete}
                     onCloseTrigger={onCloseTrigger}
                     open={open}>
                     <EventCheckInDesk returnUrl={match.url} />
                  </Modal>
               )}
            </ModalRoute>
         )}
         <TempObjectSettings />
      </Switch>
   )
}

ObjectViewRoutes.propTypes = {
   contentPaddingLeft: PropTypes.string.isRequired,
   contentPaddingRight: PropTypes.string.isRequired
}

export default ObjectViewRoutes
